import { FAQItem } from '../types';

export const laFamigliaFaq: FAQItem[] = [
  {
    id: 'faq-base-1',
    question: "Czy gra podstawowa działa w 2 lub 3 osoby?",
    answer:
      "Nie jako czysta 2vs2 z gry podstawowej. Do 2 i 3 graczy użyj oficjalnego dodatku — w aplikacji to jedna pozycja menu „Dodatek 2–3 graczy”.",
    group: "Przygotowanie",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-2',
    question: "Czy partnerzy muszą siedzieć obok siebie?",
    answer:
      "Tak w partii 4-osobowej: partnerzy siadają obok siebie, a strzałki narożników wymuszają naprzemienną kolejność tur między drużynami.",
    group: "Przygotowanie",
    players: [4],
  },
  {
    id: 'faq-base-3',
    question: "Czy na pierwszą partię używać wszystkich rodzin?",
    answer:
      "Nie. Zalecane jest odłożenie czarnej i białej oraz losowe użycie żółtej, czerwonej, zielonej i niebieskiej.",
    group: "Przygotowanie",
    players: [4],
  },
  {
    id: 'faq-base-4',
    question: "Czy obie drużyny losują niezależne kafle kontroli?",
    answer:
      "Nie. Jedna drużyna losuje 7 kafli, druga bierze dokładnie odpowiadający zestaw tych samych siedmiu rodzajów.",
    group: "Przygotowanie",
    players: [3, 4],
  },
  {
    id: 'faq-base-5',
    question: "Czy mogę użyć neutralnego znacznika wpływu?",
    answer: "Tak, bez płacenia innemu graczowi.",
    group: "Planowanie",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-6',
    question: "Czy mogę użyć wpływu partnera?",
    answer: "Tak, ale płacisz partnerowi 1 pieniądz.",
    group: "Planowanie",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-7',
    question: "Czy mogę użyć wpływu przeciwnika?",
    answer: "Tak, również płacąc właścicielowi 1.",
    group: "Planowanie",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-8',
    question: "Co, jeśli nie mam pieniędzy na cudzy wpływ?",
    answer: "Najpierw możesz sprzedać rozkaz za 1 pieniądz.",
    group: "Planowanie",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-9',
    question: "Czy muszę wykonać wszystkie części pola z „+”?",
    answer: "Możesz ograniczyć zakres, ale nie możesz całkowicie zrezygnować z akcji. Stosuj dokładny tekst pola.",
    group: "Planowanie",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-10',
    question: "Czy mogę położyć rozkaz w obszarze partnera?",
    answer: "Nie, chyba że konkretny efekt wyraźnie na to pozwala.",
    group: "Planowanie",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-11',
    question: "Czy można zaatakować pusty obszar?",
    answer: "Można się do niego przemieścić legalnym rozkazem; nie ma wtedy konfliktu kart.",
    group: "Walka",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-12',
    question: "Czy można walczyć z neutralnymi?",
    answer:
      "Tak. Neutralni bronią obszaru jak jednostki wrogie; nie należą do żadnej drużyny i nie są fikcyjną rodziną z dodatku 2–3.",
    group: "Walka",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-13',
    question: "Kto wybiera kartę za neutralnych?",
    answer:
      "Kartę konfliktu za neutralnych wybiera przeciwnik zgodnie z pomocą / zasadą konfliktu opisaną przy kartach konfliktu.",
    group: "Walka",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-14',
    question: "Czy laboratorium walczy?",
    answer: "Nie jest Soldato, ale zapewnia premię obronną.",
    group: "Walka",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-15',
    question: "Czy samochód sam utrzyma obszar?",
    answer: "Nie.",
    group: "Walka",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-16',
    question: "Czy użyty samochód zawsze jest usuwany?",
    answer: "Przy samochodzie-bombie tak. Przy zwykłym ruchu/ataku sprawdź symbol rozkazu.",
    group: "Walka",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-17',
    question: "Czy motorówka znika po przeprawie?",
    answer: "Nie, chyba że konkretny efekt tak stanowi.",
    group: "Walka",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-18',
    question: "Czy mogę użyć motorówki partnera?",
    answer: "Tak w zakresie przewidzianym zasadami połączeń i danego rozkazu.",
    group: "Walka",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-19',
    question: "Czy zamach może dać kontrolę?",
    answer: "Nie. Do przejęcia potrzebne jest legalne wejście/kontrola.",
    group: "Walka",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-20',
    question: "Czy Pentito może usunąć jednostki z kilku obszarów?",
    answer: "Tak, dokładnie w układzie liczbowym na żetonie.",
    group: "Walka",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-21',
    question: "Czy Agitate może zostawić część neutralnych?",
    answer:
      "Tak — wybierasz część lub wszystkich neutralnych z obszaru źródłowego zgodnie z zasięgiem na żetonie. Nie wolno atakować obszaru kontrolowanego przez twoją drużynę.",
    group: "Walka",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-22',
    question: "Czy trzeba zajmować wszystkie trzy obszary Mandamento Soldati?",
    answer: "Trzeba kontrolować wszystkie trzy; znacznik kontroli może utrzymywać kontrolę pustego obszaru zgodnie z zasadami.",
    group: "Kontrola i koniec gry",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-23',
    question: "Kiedy sprawdzamy zwycięstwo?",
    answer: "W zarządzaniu po fazie starcia.",
    group: "Kontrola i koniec gry",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-24',
    question: "Czy kontrola 5 Mandamenti przez jednego gracza daje zwycięstwo drużynie?",
    answer:
      "Tak — w 2vs2 i po stronie drużyny w 2vs1 wystarczy, że jeden partner sam kontroluje co najmniej 5 Mandamenti.",
    group: "Kontrola i koniec gry",
    players: [3, 4],
  },
  {
    id: 'faq-base-25',
    question: "Czy wspólne 6 Mandamenti daje zwycięstwo niezależnie od podziału?",
    answer:
      "Tak — łącznie co najmniej 6 Mandamenti partnerów wystarcza drużynie, nawet gdy żaden nie ma 5 sam.",
    group: "Kontrola i koniec gry",
    players: [3, 4],
  },
  {
    id: 'faq-base-26',
    question: "Co przy równoczesnym spełnieniu warunku?",
    answer:
      "Porównajcie liczbę Mandamenti, następnie kontrolę Bronte, a przy dalszym remisie — znacznik pierwszego gracza (zalecana poprawka dodatku).",
    group: "Kontrola i koniec gry",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-27',
    question: "Czy po remisie przed 4. rundą gra się dalej?",
    answer:
      "Tak, jeśli procedura końca nie wskazuje zwycięzcy i nie jest to koniec 4. rundy — gracie kolejną rundę.",
    group: "Kontrola i koniec gry",
    players: [2, 3, 4],
  },
  {
    id: 'faq-base-28',
    question: "Czy partner może patrzeć do mojej siedziby?",
    answer:
      "Tak. Siedziba jest tajna dla przeciwnej drużyny, ale jawna dla partnera. Zakrytego rozkazu na mapie nie odczytujcie przy przeciwnikach.",
    group: "Drużyny i komunikacja",
    sectionId: 'teams-communication',
    players: [3, 4],
  },
  {
    id: 'faq-base-29',
    question: "Czy w 1vs1 też mam partnera przy stole?",
    answer:
      "Nie. Każdy prowadzi jedną rodzinę; równowagę dają Cupola, komisja i fikcyjna rodzina — szczegóły w „Dodatek 2–3 graczy”.",
    group: "Drużyny i komunikacja",
    sectionId: 'teams-communication',
    players: [2],
  },
  {
    id: 'faq-exp-1',
    question: "Czy potrzebuję fizycznych komponentów dodatku?",
    answer: "Tak. Wariant używa kafli obszarów, blokad, znacznika ograniczenia i planszy solo.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-2',
    question: "Czy wariant 2-osobowy to zwykłe prowadzenie dwóch rodzin?",
    answer: "Nie. Każdy prowadzi jedną rodzinę, a równowagę tworzą Cupola, komisje i zmienione przygotowanie.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-3',
    question: "Czy Cupola występuje w grze 3-osobowej tak samo?",
    answer: "Nie. Głównym mechanizmem 2 na 1 są dodatkowe akcje i blokady na drugiej stronie planszy.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-4',
    question: "Czy członek komisji jest zwykłym Soldato?",
    answer: "Tylko przy wyborze źródła efektu; po umieszczeniu w Cupoli działa wyłącznie jako członek komisji.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-5',
    question: "Czy można mieć więcej niż 12 członków w Cupoli?",
    answer: "Nie, Cupola ma 12 miejsc.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-6',
    question: "Co się dzieje z wypartym członkiem komisji?",
    answer: "Wraca do zapasu właściciela.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-7',
    question: "Czy osoba z większością Cupoli musi wykorzystać pełny bonus początku rundy?",
    answer: "Nie.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-8',
    question: "Czy kontrola Cupoli aktualizuje się na początku rundy?",
    answer: "Nie, znacznik kontroli ustala się w zarządzaniu po fazie starcia.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-9',
    question: "Czy dodatkowe wpływy komisji spowalniają rozwój planszy rodziny?",
    answer: "Tak. Muszą zostać zdjęte przed własnymi znacznikami na pięciu podwójnych polach.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-10',
    question: "Czy 2 na 1 jest kooperacją dwóch graczy przeciw samotnemu?",
    answer: "Tak, ale wszyscy rywalizują zgodnie z pełnymi zasadami drużynowymi.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-11',
    question: "Jaki poziom trudności wybrać?",
    answer: "Średni jest ustawieniem domyślnym przy podobnym doświadczeniu. Łatwy wspiera samotnego bardziej, trudny ogranicza go mocniej.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-12',
    question: "Kto zaczyna w 2 na 1?",
    answer: "Gracz samotny otrzymuje znacznik pierwszego gracza.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-13',
    question: "Czy samotny może wykonać dodatkową akcję przed normalną?",
    answer: "Instrukcja pozwala wykonać ją w swojej turze; przestrzegaj kolejności ikon/akcji na planszy i rozlicz całą jedną akcję przed następną.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-14',
    question: "Czy dwa wpływy komisji zdjęte jedną akcją aktywują dwa pola?",
    answer: "Tak, jeśli oficjalna akcja pozwoliła zdjąć dwa znaczniki komisji.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-15',
    question: "Czy wpływy komisji na planszy solo wracają na koniec rundy 2 na 1?",
    answer: "Nie. Wracają dodatkowe znaczniki akcji; wpływy zdjęte z planszy rodziny są usuwane po wykorzystaniu/na końcu zgodnie z instrukcją.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-16',
    question: "Czy fikcyjna rodzina może przejąć nowe obszary?",
    answer: "Sama nie atakuje, więc nie wykonuje ekspansji. Może jedynie bronić początkowych pozycji.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-17',
    question: "Kto podejmuje decyzje obronne fikcyjnej rodziny?",
    answer: "Gracz z przeciwnej drużyny.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-18',
    question: "Czy można użyć Pentito przeciw fikcyjnej rodzinie?",
    answer: "Traktuj jej Soldati jak Soldati gracza w zakresie usuwania, ale nie przyznawaj bonusu za neutralnych.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-19',
    question: "Czy w 1 na 1 kontrola Cupoli może dać 5. Mandamento i natychmiast wygrać?",
    answer: "Tak, podczas sprawdzenia końca rundy.",
    group: "Dodatek 2–3",
    players: [2, 3],
  },
  {
    id: 'faq-exp-20',
    question: "Co rozstrzyga ostateczny remis?",
    answer: "Mandamenti, następnie Bronte, następnie znacznik pierwszego gracza.",
    group: "Dodatek 2–3",
    players: [2, 3],
  }
];
